module.exports = __webpack_public_path__ + "img/tu2.ccd082a4.png";